import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, message } from "antd";
import { GrantsTable } from "../../style";
import RemovePopup from "../../../../../../CommonComponents/CharitySearch/Component/RemovePopup/RemovePopup";
import RemoveGeminiPopup from "../../../../../../CommonComponents/CharitySearch/Component/RemoveGemini/RemoveGeminiPopup";
import { tableConfig } from "../../../../../../CommonComponents/CharitySearch/config";
import { geminiTableConfig } from "../../../../../../CommonComponents/CharitySearch/geminiConfig";
import MultipleCharityPopup from "../../../../../../CommonComponents/CharitySearch/Component/MultipleCharity/MultipleCharity";
import RenderCard from "../RenderCard/RenderCard";
import { LoadMoreButton, EndResult } from "./style";
import {
  updateFromCounter,
  updateLoadMoreCounter,
  updateFrom,
  geminiEinData,
  einData,
  cancelSaveCharity,
  pageScroll,
  postSavedCharity,
} from "../../actions";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import { handleGuideStarRedirect } from "../../../../../../CommonComponents/CharitySearch/utils";
import { charityEligibilityChecker } from "../../../../../../utils/commonUtil";
import DrupalPopup from "../Popup/DrupalPopup";

import { searchTableDerivedStates } from '../../Selectors/SearchTableSelectors';

export class SearchTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: 2,
      counter: 1,
      visiblePopup: false,
      visibleGeminiPopup: false,
      showSavedCharityData: "",
      savedGeminiData: "",
      fetchGeminiEinSuccessData: "",
      ein: "",
      legalName: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      state: "",
      city: "",
      country: "",
      zip: "",
      charityContactFirstName: "",
      charityContactLastName: "",
      email: "",
      phoneNumber: "",
      selectedCharity: {},
      multipleCharities: [],
      partialEligibility: false,
      eligible: true,
      selectedCharityData: {},
    };
    this.multipleCharitySaveHandler = this.multipleCharitySaveHandler.bind(
      this
    );
  }

  savedCharityModal = (data) => {
    this.setState({
      visiblePopup: !this.state.visiblePopup,
      showSavedCharityData: data,
      showPopup: !this.state.showPopup,
    });
  };

  savedGeminiModal = (data) => {
    this.setState({
      visibleGeminiPopup: !this.state.visibleGeminiPopup,
      savedGeminiData: data,
    });
  };

  handleMapping = (data) => {
    const cloneState = { ...data };
    const keyArr = Object.keys(cloneState);
    let newObj = {};
    keyArr.forEach((item, i) => {
      if (data[item]) {
        newObj[item] = data[item];
      } else {
        if (data[item] !== undefined) newObj[item] = "";
      }
    });
    return newObj;
  };

  removeSavedCharityModal = (data) => {
    const obj = this.handleMapping(data);
    this.setState({ selectedCharityData: obj });
    const eligibility = charityEligibilityChecker({
      pub78: obj.properties.pub78_verified,
      bmfStatus: obj.properties.bmf_status,
      subSection: obj.subsection_code,
      foundationCode: obj.foundation_code,
    });
    if (eligibility.mandatory && eligibility.partial) {
      this.props.saveCharity(obj, this.multipleCharitySaveHandler);
    } else if (eligibility.mandatory && !eligibility.partial) {
      this.setState({ partialEligibility: true });
    } else {
      this.setState({ eligible: false });
    }
  };

  saveInEligibleCharities = () => {
    const { selectedCharityData } = this.state;
    this.setState({ partialEligibility: false, eligible: true });
    let recordToSave = {
      ein: selectedCharityData.ein,
      legalName: selectedCharityData.organization_name,
      addressLine1: selectedCharityData.address_line_1,
      addressLine2: selectedCharityData.address_line_2,
      addressLine3: "",
      state: selectedCharityData.state,
      city: selectedCharityData.city,
      country: "US",
      zip: selectedCharityData.zip,
      charityContactFirstName: selectedCharityData.contact_name,
      charityContactLastName: "",
      email: selectedCharityData.contact_email,
      phoneNumber: selectedCharityData.contact_phone,
    };
    this.props.postSavedCharity(
      {
        userId: getPrimaryAccount().userId,
        charityData: recordToSave,
      },
      (response) =>
        this.multipleCharitySaveHandler(response, selectedCharityData)
    );
  };

  multipleCharitySaveHandler = (savedRecord, reqRecord) => {
    if (savedRecord.isExisting) {
      if (savedRecord.granteeOrgs && savedRecord.granteeOrgs.length === 1) {
        // add charity directly and proceed
        this.saveSelectedCharity(savedRecord.granteeOrgs[0]);
      } else if (
        savedRecord.granteeOrgs &&
        savedRecord.granteeOrgs.length > 1
      ) {
        // show multiple charity popup
        // if user tries to save multiple with ein conflict, keep first cancel rest
        if (!Object.keys(this.state.selectedCharity).length) {
          this.setState({
            multipleCharities: savedRecord.granteeOrgs,
            selectedCharity: { ...reqRecord },
          });
        } else {
          this.props.cancelSaveCharity(reqRecord);
        }
      }
    }
  };

  saveSelectedCharity = (charity) => {
    this.props.addCharity(charity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  onCancelMultipleCharity = () => {
    this.props.cancelSaveCharity(this.state.selectedCharity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  removedGeminiModal = (data) => {
    this.props.saveGeminiCharity(data);
    this.setState({
      fetchGeminiEinSuccessData: data.ein,
    });
  };

  updateFromCounter = (data) => {
    this.setState(
      (prev) => {
        return { visible: prev.visible + data };
      },
      () => {
        this.props.updateLoadMoreCounter(data);
      }
    );
  };

  savedCharityHandler = () => {
    message.success("Your charity is saved");
    this.props.getSavedCharity(getPrimaryAccount().userId);
  };

  componentWillReceiveProps(nextprops) {
    if (
      nextprops.charitySaved &&
      nextprops.charitySaved !== this.props.charitySaved
    ) {
      this.savedCharityHandler();
    }

    if (
      this.props.updatedSearchData.length !== nextprops.updatedSearchData.length
    ) {
      let counter = nextprops.updatedCounterData;
      this.setState({ counter: counter });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.updatedSearchData.length !== prevProps.updatedSearchData.length
    ) {
      // When you click load more, additional charities load, but you are still shown the bottom of the list and the load more button again.
      // To maintain the visibility in the place we added auto focus with scrollTo
      window.scrollTo(0, this.props.currentPageScroll);
    }
  }

  render() {
    const {
      columnData,
      updatedSearchData,
      pendingCharityHandler,
      showGeminiFilter,
      activityBlocked = "",
      isFindACharity,
    } = this.props;
    const {
      counter,
      showSavedCharityData,
      visiblePopup,
      visibleGeminiPopup,
      savedGeminiData,
      multipleCharities,
    } = this.state;
    const {
      savedCharityModal,
      removeSavedCharityModal,
      removedGeminiModal,
      savedGeminiModal,
    } = this;
    return (
      <div>
        <Row>
          {showGeminiFilter ? (
            <>
              <Col lg={24} md={24} xs={0}>
                <GrantsTable
                  className="main"
                  columns={geminiTableConfig(
                    pendingCharityHandler,
                    savedGeminiModal,
                    removedGeminiModal,
                    activityBlocked
                  )}
                  dataSource={columnData}
                  pagination={false}
                />
                <EndResult>
                  You have reached the end of search results.
                </EndResult>
              </Col>
              <Col lg={0} md={0} xs={24}>
                {columnData.map((data, index) => (
                  <RenderCard
                    key={data.granteeOrgId}
                    index={index}
                    data={data}
                    component="SearchGeminiCard"
                    pendingCharityHandler={pendingCharityHandler}
                    removedGeminiModal={removedGeminiModal}
                    savedGeminiModal={savedGeminiModal}
                    activityBlocked={activityBlocked}
                  />
                ))}
                <EndResult>
                  You have reached the end of search results.
                </EndResult>
              </Col>
            </>
          ) : (
            <>
              <Col lg={24} md={24} xs={0}>
                <GrantsTable
                  className="main"
                  columns={tableConfig(
                    pendingCharityHandler,
                    savedCharityModal,
                    removeSavedCharityModal,
                    activityBlocked,
                    handleGuideStarRedirect
                  )}
                  dataSource={updatedSearchData}
                  pagination={false}
                />
                {this.props.guidestarSearchCount === columnData.length ? (
                  <div></div>
                ) : (
                  <LoadMoreButton
                    data-test="load-more"
                    id="btnLoadMore1"
                    onClick={(e) => {
                      this.props.pageScroll(window.pageYOffset);
                      this.props.updateFrom(window.pageYOffset);
                    }}
                  >
                    {" "}
                    Load more
                  </LoadMoreButton>
                )}
              </Col>
              <Col lg={0} md={0} xs={24}>
                {updatedSearchData.map((data, index) => (
                  <RenderCard
                    key={data.organization_id}
                    index={index}
                    data={data}
                    component="SearchCharityCard"
                    pendingCharityHandler={pendingCharityHandler}
                    removeSavedCharityModal={removeSavedCharityModal}
                    savedCharityModal={savedCharityModal}
                    activityBlocked={activityBlocked}
                    searchResultClickHandler={handleGuideStarRedirect}
                  />
                ))}
                {this.props.guidestarSearchCount === columnData.length ? (
                  <div></div>
                ) : (
                  <LoadMoreButton
                    data-test="load-more2"
                    id="btnLoadMore2"
                    onClick={() => {
                      this.props.pageScroll(window.pageYOffset);
                      this.props.updateFrom();
                    }}
                  >
                    {" "}
                    Load more
                  </LoadMoreButton>
                )}
              </Col>
            </>
          )}
        </Row>
        {visiblePopup ? (
          <RemovePopup
            page={
              this.props.isFindACharity ? "Find a charity" : "Recommend a Grant"
            }
            showSavedCharityData={showSavedCharityData}
            removeCharity={this.props.removeSavedCharity}
            einData={this.props.einData}
            keyProperty={
              this.props.isFindACharity
                ? "Remove Charity Find a Charity"
                : "Remove Charity Recommend a Grant"
            }
          />
        ) : (
          <div />
        )}

        {visibleGeminiPopup ? (
          <RemoveGeminiPopup
            page={
              this.props.isFindACharity ? "Find a charity" : "Recommend a Grant"
            }
            savedGeminiData={savedGeminiData}
            removeCharity={this.props.removeSavedCharity}
            geminiEinData={this.props.geminiEinData}
            keyProperty={
              this.props.isFindACharity
                ? "Remove Charity Find a Charity"
                : "Remove Charity Recommend a Grant"
            }
          />
        ) : (
          <div />
        )}

        {multipleCharities.length ? (
          <MultipleCharityPopup
            show={!!multipleCharities.length}
            charities={multipleCharities}
            secondaryCta={this.onCancelMultipleCharity}
            primaryCta={this.saveSelectedCharity}
          />
        ) : (
          ""
        )}
        <DrupalPopup
          data-test="eligibility"
          html={true}
          page={isFindACharity ? "Find a charity" : "Recommend a Grant"}
          show={!this.state.eligible}
          defaultPrimaryLabel={"Ok"}
          defaultSecondaryLabel={"Cancel"}
          defaultTitle={"Warning"}
          keyProperty={"Ineligible"}
          defaultDescription={"you are ineligible"}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ eligible: true })}
          alertId='rag-ineligibility'
        />
        <DrupalPopup
          data-test="partial"
          html={true}
          page={isFindACharity ? "Find a charity" : "Recommend a Grant"}
          show={this.state.partialEligibility}
          defaultPrimaryLabel={"Ok"}
          defaultSecondaryLabel={"Cancel"}
          defaultTitle={"Warning"}
          keyProperty={"Partial Eligible"}
          defaultDescription={"you are ineligible"}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ partialEligibility: false })}
          alertId='rag-partial-eligibility'
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...searchTableDerivedStates(state.toJS())
});

export const mapDispatchToProps = (dispatch) => ({
  updateFrom: () => dispatch(updateFrom()),
  updateLoadMoreCounter: (data) => dispatch(updateLoadMoreCounter(data)),
  geminiEinData: (data) => dispatch(geminiEinData(data)),
  einData: (data) => dispatch(einData(data)),
  cancelSaveCharity: (data) => dispatch(cancelSaveCharity(data)),
  pageScroll: (data) => dispatch(pageScroll(data)),
  postSavedCharity: (data, successFn) =>
    dispatch(postSavedCharity(data, successFn)),
});

SearchTable.propTypes = {
  activityBlocked: PropTypes.any,
  addCharity: PropTypes.func,
  cancelSaveCharity: PropTypes.func,
  charitySaved: PropTypes.bool,
  columnData: PropTypes.arrayOf(
    PropTypes.shape({
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      also_known_as: PropTypes.string,
      bmf_assets: PropTypes.string,
      bmf_gross_receipts: PropTypes.string,
      bridge_id: PropTypes.string,
      city: PropTypes.string,
      contact_email: PropTypes.string,
      contact_name: PropTypes.string,
      contact_phone: PropTypes.string,
      county: PropTypes.string,
      ein: PropTypes.string,
      foundation_code: PropTypes.string,
      isSelected: PropTypes.bool,
      lat_long: PropTypes.string,
      mission: PropTypes.string,
      ntee_code: PropTypes.string,
      number_of_employees: PropTypes.string,
      organization_id: PropTypes.string,
      organization_name: PropTypes.string,
      parent_orgs: PropTypes.string,
      profile_level: PropTypes.string,
      properties: PropTypes.object,
      state: PropTypes.string,
      subsection_code: PropTypes.string,
      zip: PropTypes.string,
    })
  ),
  currentPageScroll: PropTypes.any,
  einData: PropTypes.func,
  geminiEinData: PropTypes.func,
  getSavedCharity: PropTypes.func,
  guidestarSearchCount: PropTypes.number,
  isFindACharity: PropTypes.bool,
  pageScroll: PropTypes.func,
  pendingCharityHandler: PropTypes.func,
  postSavedCharity: PropTypes.func,
  removeSavedCharity: PropTypes.func,
  saveCharity: PropTypes.func,
  saveGeminiCharity: PropTypes.func,
  showGeminiFilter: PropTypes.bool,
  updateFrom: PropTypes.func,
  updateLoadMoreCounter: PropTypes.func,
  updatedCounterData: PropTypes.number,
  updatedSearchData: PropTypes.arrayOf(
    PropTypes.shape({  
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      also_known_as: PropTypes.string,
      bmf_assets: PropTypes.string,
      bmf_gross_receipts: PropTypes.string,
      bridge_id: PropTypes.string,
      city: PropTypes.string,
      contact_email: PropTypes.string,
      contact_name: PropTypes.string,
      contact_phone: PropTypes.string,
      county: PropTypes.string,
      ein: PropTypes.string,
      foundation_code: PropTypes.string,
      isSelected: PropTypes.bool,
      mission: PropTypes.string,
      organization_id: PropTypes.string,
      organization_name: PropTypes.string,
      properties: PropTypes.object,
      state: PropTypes.string,
      subsection_code: PropTypes.string,
      zip: PropTypes.string,
    })
  ),
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: true,
})(SearchTable);
